<template>
  <div class="mt-2">
    <WarningDisable permission="last_activity" />
    <div class="flex flex-wrap gap-6">
      <div>
        <form
          ref="status_form"
          class="mb-4 space-y-4"
          @submit="submit_without_reloading"
          @reset="keyword = undefined"
        >
          <div class="space-y-2">
            <div>
              <legend>Từ khóa</legend>
              <label class="input w-full md:w-fit 2xl:w-fit">
                <i
                  class="fa-solid fa-magnifying-glass text-base-content/80"
                ></i>
                <input
                  type="text"
                  placeholder="Tìm kiếm theo từ khóa"
                  name="keyword"
                  v-model="keyword"
                />
              </label>
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            <input
              class="btn btn-outline grow"
              type="reset"
              value="&#8635; Đặt lại"
              :disabled="last_activity_store.loading.get_last_activities"
            />
            <button
              class="btn btn-primary btn-outline grow"
              type="submit"
              :disabled="
                !filter_has_changed ||
                last_activity_store.loading.get_last_activities
              "
            >
              &#10003; Áp dụng
            </button>
          </div>
        </form>
      </div>

      <div class="flex grow flex-col">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Danh sách hoạt động gần đây
        </div>
        <Loading v-if="last_activity_store.loading.get_last_activities" />
        <template v-else-if="last_activity_store.total_filter > 0">
          <div class="bg-base-100 mb-2 overflow-x-auto">
            <table class="table-pin-rows table-md border-base-300 table border">
              <thead>
                <tr>
                  <th>Tên file</th>
                  <th>Mô tả</th>
                  <th>Thời gian</th>
                  <th>Hành động</th>
                </tr>
              </thead>
              <tbody class="bg-base-200">
                <tr
                  v-for="activity in last_activity_store.last_activities"
                  :key="activity.id"
                >
                  <td class="text-base-content/80 text-base font-bold">
                    {{ activity?.file_name }}
                  </td>
                  <td>{{ activity?.description }}</td>
                  <td>
                    {{ dayjs(activity?.action_time).fromNow() }} -
                    {{
                      dayjs(activity?.action_time).format("DD/MM/YYYY HH:mm:ss")
                    }}
                  </td>
                  <td>
                    <button class="btn" @click="openDetailDialog(activity)">
                      <i class="fa-solid fa-circle-info text-base-content/90" />
                      Chi tiết
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :total_pages="last_activity_store.total_pages" />
        </template>
        <NotFound v-else />
      </div>
    </div>
  </div>
  <LastActivityDetailDialog ref="detailDialogRef" />
</template>

<script setup lang="ts">
import { str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import { use_last_activity } from "./useLastActivity";
import LastActivityDetailDialog from "./LastActivityDetail/LastActivityDetailDialog.vue";
import type { LastActivity } from "@/api/lastActivity";

const init_keyword = computed(() => str_from_query("keyword"));

const keyword = ref<string | undefined>(init_keyword.value);
const filter_has_changed = computed(() => keyword.value !== init_keyword.value);
const last_activity_store = use_last_activity();

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
    },
  });
};

const detailDialogRef = ref<InstanceType<
  typeof LastActivityDetailDialog
> | null>(null);

const openDetailDialog = (activity: LastActivity) => {
  detailDialogRef.value?.openDialog(activity);
};
</script>
